// extracted by mini-css-extract-plugin
module.exports = {"signIn":"pk9TFCJRgVrKo-KQikGCK","signUpLink":"TTh95P8E6JY5-CVIhdtwg","forgotPasswordLink":"_23qS2ZAW5y3AtN9rTpxou5","signInHeading":"_1nJQeZPDT9xOTmDBqXLoIB"};